// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLTileComponent__errorIcon{color:var(--GW-COLOR-ERROR);padding-left:5px;vertical-align:text-top}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-quoteandbind-common-react/components/MLTileComponent/MLTileComponent.module.scss"],"names":[],"mappings":"AAAA,iCACE,2BAAA,CAEA,gBAAA,CADA,uBACA","sourcesContent":[".errorIcon {\n  color: var(--GW-COLOR-ERROR);\n  vertical-align: text-top;\n  padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorIcon": "app__MLTileComponent__errorIcon"
};
export default ___CSS_LOADER_EXPORT___;
